<template>
  <div class="card_use_record_wrap">
    <div class="header">
      <el-col :span="19">
        <el-button size="medium" @click="goBack">返回</el-button>
        <el-select v-model="listQuery.status" placeholder="请选择使用状态" size="medium" @change="getIntegralCardUsePageList">
          <el-option v-for="(item, index) in statusList" :key="index" :label="item" :value="index"></el-option>
        </el-select>
      </el-col>
      <el-col :span="5">
        <el-input placeholder="请输入卡号" size="medium" v-model.trim="listQuery.cardNo" @change="getIntegralCardUsePageList">
          <el-button slot="append" icon="el-icon-search" @click="getIntegralCardUsePageList"></el-button>
        </el-input>
      </el-col>
    </div>
    <el-table stripe :data="dataList" :height="`${windowHeight - 210}px`" border style="width: 100%">
      <el-table-column align="center" label="卡名称" prop="cardName" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="卡积分" prop="point" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="卡号" prop="cardNo" show-overflow-tooltip></el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 2">已使用</span>
          <span v-else>未使用</span>
        </template>
      </el-table-column>
      <el-table-column label="使用学校" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.useSchoolName || '--'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="使用人" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.useName || '--'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="使用时间" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.useTime | timeFormat}}</span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="pagination-container" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                   :current-page.sync="listQuery.pageNo" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pageSize"
                   layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
  </div>
</template>

<script>
  import windowResize from "@/mixins/windowResize";
  import {getIntegralCardUsePageList} from '@/api/integralBank';

  export default {
    name: "cardUseRecord",
    data() {
      return {
        statusList: ['全部', '未使用', '已使用'],
        dataList: [],
        listQuery: {
          pageNo: 1,
          pageSize: 20,
          cardNo: '',
          status: 0,
          batchId: this.$route.query.batchId
        },
        total: null
      }
    },
    filters: {
      timeFormat(time) {
        return time ? time.substring(0, 19) : "--";
      },
    },
    mixins: [windowResize],
    created() {
      this.getIntegralCardUsePageList();
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      getIntegralCardUsePageList() {
        getIntegralCardUsePageList(this.listQuery).then(res => res.data).then(data => {
          if (data.code === 200 && data.result) {
            this.dataList = data.data.dataList;
            this.total = data.data.pagination.total;
          }
        });
      },
      //切换码数
      handleSizeChange(val) {
        this.listQuery.pageNo = 1;
        this.listQuery.pageSize = val;
        this.getIntegralCardUsePageList();
      },
      //切换页数
      handleCurrentChange(val) {
        this.listQuery.pageNo = val;
        this.getIntegralCardUsePageList();
      },
    }
  }
</script>

<style lang="scss" scoped>
  .card_use_record_wrap{
    padding: 12px;

    .header {
      padding-bottom: 10px;
      overflow: hidden;
    }
    .picimg{
      display: block;
      width: 28px;
      height: 21px;
      margin: 0 auto;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/integralBank/cardUseRecord.vue